export default __webpack_public_path__ + "static/media/pro-icon.04e9421d.png";